import { ArrayFuncs } from '../../../foundation/js/array.funcs';
import { NodeStore } from './node.store';

function findAllSubNodeIds(nodeId: string): string[] {
  const node = NodeStore.getItem(nodeId);

  const sub = ArrayFuncs.ensure(node?.sub);

  if (ArrayFuncs.isEmpty(sub)) {
    return [nodeId];
  }

  return [nodeId, ...sub.flatMap((subNodeId) => findAllSubNodeIds(subNodeId))];
}

export const NodeService = {
  findAllSubNodeIds,
};
